import React, { ReactElement } from 'react';
import clsx from 'clsx';

import { CartItemProps } from '~/types/cart';
import { currencyWithCents } from '~/lib/format';

interface CartItemPricingProps {
  post_discount_total: CartItemProps['post_discount_total'];
  coupon_discount: CartItemProps['coupon_discount'];
  price: CartItemProps['price'];
  subtotal: CartItemProps['subtotal'];
}

export default React.memo(function CartItemPricing({
  cartItem,
  autoCampaignCouponApplied,
  isCompletePage,
}: Readonly<{
  cartItem: CartItemPricingProps;
  autoCampaignCouponApplied: boolean;
  isCompletePage?: boolean;
}>): ReactElement {
  const priceString = cartItem.subtotal
    ? `${currencyWithCents(cartItem.subtotal)}`
    : 'FREE';
  const discountClass = clsx(
    'mt-[2px] self-start font-medium',
    isCompletePage ? 'text-brick' : 'text-money-moss',
  );
  const originalClass = clsx(
    'mt-[2px] self-start text-grace line-through',
    !isCompletePage && 'text-sm',
  );

  if (!cartItem.coupon_discount || !autoCampaignCouponApplied) {
    return (
      <p className="mt-[2px] self-start font-medium text-midnight">
        {priceString}
      </p>
    );
  }

  // Sumo Day Pricing, should generalize for other campaigns like BF
  return (
    <>
      <div>
        <p className={discountClass}>
          {cartItem.price
            ? `${currencyWithCents(cartItem.post_discount_total)}`
            : 'FREE'}
        </p>
      </div>
      <div>
        <p className={originalClass}>{priceString}</p>
      </div>
    </>
  );
});
